import View from './View.js';
import banner0 from '../../img/banner0.png';
import banner2 from '../../img/banner2.png';
import banner3 from '../../img/banner3.png';

class HomepageView extends View {
  _parentElement = document.querySelector('.recipe');
  _errorMessage = `We could not find the Homepage!`;
  _message = ``;

  addHandlerLogoBtn(handler) {
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.header__logo');
      if (!btn) return;

      handler();
    });
  }

  _generateMarkup() {
    return `
    <div class="recipe__body">
            <div class="image-1">
              <img src="${banner3}" alt="banner3" />
            </div>
            <div class="image-2">
              <img src="${banner0}" alt="banner0" />
            </div>
            <div class="image-3">
              <img src="${banner2}" alt="banner2" />
            </div>
          </div>`;
  }
}

export default new HomepageView();
